import { render, staticRenderFns } from "./PersonalLoanStatusTable.vue?vue&type=template&id=319ef88e"
import script from "./PersonalLoanStatusTable.vue?vue&type=script&lang=js"
export * from "./PersonalLoanStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports